import React, { Component } from "react";

export default class Signbutton extends Component {
  render() {
    return (
      <div
        style={
          this.props.center && { display: "flex", justifyContent: "center" }
        }
      >
        <button
          className={
            !!this.props.isDark
              ? "login-button-sign-in-dark"
              : "login-button-sign-in"
          }
          onClick={this.props.onClick}
          disabled={this.props.disabled}
          style={{
            padding: this.props.padding,
            width: !!this.props.width ? this.props.width : "100%",
            marginTop: this.props.margin ? this.props.margin : 30,
            textTransform: this.props.texttransform ? "" : "uppercase",
            backgroundColor:
              this.props.disabled &&
              (this.props.buttontitle === "Verify OTP" ||
                this.props.buttontitle === "ReSend OTP")
                ? "grey"
                : this.props.backgroundcolor || "",
          }}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}
export class NpsConfirmButton extends Component {
  render() {
    return (
      <button
        className={!!this.props.className ? this.props.className : "nps-button"}
        onClick={this.props.onClick}
        disabled={!!this.props.disabled ? this.props.disabled : false}
      >
        {this.props.title}
      </button>
    );
  }
}
export class Debtbutton extends Component {
  render() {
    return (
      <div>
        <button
          disabled={this.props.disabled}
          className={
            this.props.active
              ? "login-button-debt-button-active"
              : "login-button-debt-button"
          }
          style={{
            width: this.props.width ? this.props.width : 120,
            textTransform: this.props.textTransform
              ? this.props.textTransform
              : "uppercase",
          }}
          onClick={this.props.onClick}
          onMouseDown={this.props.onClick}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}

export class DebtbuttonActive extends Component {
  render() {
    return (
      <div>
        <button
          className="login-button-debt-button-active"
          onClick={this.props.onClick}
          style={{ outline: 0, textTransform: "uppercase" }}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}

export class DebtbuttonNowidth extends Component {
  render() {
    return (
      <div>
        <button
          className="login-button-debt-button-active-no-width"
          onClick={this.props.onClick}
          style={{ textTransform: "uppercase" }}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}
